export type User = {
  id?: number;
  email: string;
  firstName: string;
  lastName: string;
  uuid: string;
};

export const defaultUser = {
  email: "",
  firstName: "",
  lastName: "",
  uuid: "",
};
